import { api } from "../config/api";

export const getNotifications = async () => {
    const response = await api.get("/Notifications/me");
    return response.data;
};

export const markNotificationRead = async (notificationId) => {
  const response = await api.put(`/Notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
    const response = await api.put("/Notifications/me/read-all");
    return response.data;
};